// extracted by mini-css-extract-plugin
export default {"mealCard":"Cards-module_mealCard_LdF_uJLv8t","lowShippingCard":"Cards-module_lowShippingCard_rsxwhn_aRp"};